import { Checkbox, Datepicker, Flex, FlexProps } from "@fluentui/react-northstar";
import { FieldDescriptor } from "@shopify/react-form-state";
import { SurveyLimits } from "@teams/cards";
import moment from "moment";
import React from "react";

import { FieldLabel, TimeField } from "../../../../_shared/components/fields";
import { RRule, rruleString } from "../../../../_shared/utils/recurringHelpers";
import { copyTimeToDate } from "../../../../_shared/utils/timeUtils";
import { RRuleField } from "./RRuleField";

type Props = {
  isEdit?: boolean;
  rrule: FieldDescriptor<string>;
  sendAt: FieldDescriptor<Date>;
  rruleRequired?: boolean;
  column?: boolean;
  gap?: FlexProps["gap"];
  isCloseTime?: boolean;
  hideRecurring?: boolean;
};

export const SchedulePollyField: React.FC<Props> = ({
  isEdit,
  rrule,
  rruleRequired,
  sendAt,
  column,
  gap,
  isCloseTime,
  hideRecurring,
}) => {
  return (
    <Flex column gap={gap || "gap.medium"}>
      <Flex.Item grow>
        <Flex column gap="gap.medium">
          <Flex gap="gap.large">
            <Flex gap="gap.small" vAlign="center" column={column}>
              <FieldLabel label={isCloseTime ? "" : "Send on"} />
              <Flex>
                <Datepicker
                  allowManualInput={false}
                  selectedDate={sendAt.value}
                  minDate={isEdit ? new Date() : undefined}
                  maxDate={moment()
                    .add(moment.duration(SurveyLimits.DeliverAt.MaxDurationFromNow))
                    .toDate()}
                  onDateChange={(_, v) => {
                    if (v) {
                      const update = copyTimeToDate(v.value, sendAt.value);
                      sendAt.onChange(update);
                    }
                  }}
                  input={{
                    value: moment(sendAt.value).format("LL"),
                  }}
                />
              </Flex>
            </Flex>

            <Flex gap="gap.small" vAlign="center" column={column}>
              <FieldLabel label={isCloseTime ? "" : "At time"} />
              <TimeField field={sendAt} minuteIntervals={15} fluid />
            </Flex>
          </Flex>

          {!isCloseTime && !hideRecurring && (
            <Flex gap="gap.small" vAlign="center">
              <FieldLabel label="Recurring" />
              <Checkbox
                toggle
                checked={!!rrule.value || rruleRequired}
                disabled={rruleRequired}
                onChange={(_, d) => {
                  if (d?.checked) {
                    rrule.onChange("RRULE:FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,TU,WE,TH,FR");
                  } else if (!rruleRequired) {
                    rrule.onChange("");
                  }
                }}
              />
            </Flex>
          )}

          {!!rrule.value && (
            <RRuleField
              ruleString={rrule.value}
              onRRuleChangeHandler={(rule: RRule) => {
                const ruleString = rruleString(rule);
                rrule.onChange(ruleString);
              }}
            />
          )}
        </Flex>
      </Flex.Item>
    </Flex>
  );
};
